import { useEffect, useRef } from "react"
import ModalWrapper from "../modal/ModalWrapper"
import useUiuxStore from "src/store/useUiuxStore";
import { useWMS1020_R01Store } from "src/containers/mes/WMS/WMS1020_R01/Store_WMS1020_R01";
import { useWMS1021_R01Store } from "src/containers/mes/WMS/WMS1021_R01/Store_WMS1021_R01";
import { useSAL2070_R01Store } from "src/containers/mes/SAL/SAL2070_R01/Store_SAL2070_R01";
import { usePRD2010_R01Store } from "src/containers/mes/PRD/PRD2010_R01/Store_PRD2010_R01";
import { useWMS1030_R01Store } from "src/containers/mes/WMS/WMS1030_R01/Store_WMS1030_R01";
import { usePRD3010_R01Store } from "src/containers/mes/PRD/PRD3010_R01/Store_PRD3010_R01";
import { useSAL1011_R01Store } from "src/containers/mes/SAL/SAL1011_R01/Store_SAL1011_R01";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useSAL1010_R01Store } from "src/containers/mes/SAL/SAL1010_R01/Store_SAL1010_R01";
import { useMST3010_R01Store } from "src/containers/mes/MST/MST3010_R01/Store_MST3010_R01";
import useSYS2010_R01Store from "src/containers/mes/SYS/SYS2010_R01/Store_SYS2010_R01";
import { useSYS3010_R01Store } from "src/containers/mes/SYS/SYS3010_R01/Store_SYS3010_R01";
import { useSYS4100_R01Store } from "src/containers/mes/SYS/SYS4100_R01/Store_SYS4100_R01";
import { useMST3040_R01Store } from "src/containers/mes/MST/MST3040_R01/Store_MST3040_R01";
import { useWMS2020_R01Store } from "src/containers/mes/WMS/WMS2020_R01/Store_WMS2020_R01";
import { usePRD1010_R01Store } from "src/containers/mes/PRD/PRD1010_R01/Store_PRD1010_R01";
import { useSYS4030_R01Store } from "src/containers/mes/SYS/SYS4030_R01/Store_SYS4030_R01";
import { useSYS4090_R01Store } from "src/containers/mes/SYS/SYS4090_R01/Store_SYS4090_R01";
import { useSYS4120_R01Store } from "src/containers/mes/SYS/SYS4120_R01/Store_SYS4120_R01";
import { usePUR2010_R01Store } from "src/containers/mes/PUR/PUR2010_R01/Store_PUR2010_R01";
import { usePUR1030_R01Store } from "src/containers/mes/PUR/PUR1030_R01/Store_PUR1030_R01";
import { usePRD3020_R01Store } from "src/containers/mes/PRD/PRD3020_R01/Store_PRD3020_R01";
import { useWMS1130_R01Store } from "src/containers/mes/WMS/WMS1130_R01/Store_WMS1130_R01";
import { useWMS1131_R01Store } from "src/containers/mes/WMS/WMS1131_R01/Store_WMS1131_R01";
import useUserStore from "src/store/useUserStore";
import { useSAL2020_R01Store } from "src/containers/mes/SAL/SAL2020_R01/Store_SAL2020_R01";
import { useWMS1100_R01Store } from "src/containers/mes/WMS/WMS1100_R01/Store_WMS1100_R01";
import { hoverColor } from 'src/components/common/common';
import { SYS4030_R01Content } from "src/containers/mes/SYS/SYS4030_R01/Content_SYS4030_R01";
import { AgGridReact } from "ag-grid-react";
import { SYS4030_R01Dto } from "src/containers/mes/SYS/SYS4030_R01/Dto_SYS4030_R01";
import { useEQM2050_R01Store } from "src/containers/mes/EQM/EQM2050_R01/Store_EQM2050_R01";
import { useWMS1140_R01Store } from "src/containers/mes/WMS/WMS1140_R01/Store_WMS1140_R01";
import { usePUR6010_R01Store } from "src/containers/mes/PUR/PUR6010_R01/Store_PUR6010_R01";
import config from "src/config";
import { useEQM3020_R01Store } from "src/containers/mes/EQM/EQM3020_R01/Store_EQM3020_R01";
import { useMST4040_R01Store } from "src/containers/mes/MST/MST4040_R01/Store_MST4040_R01";
import { useEQM2080_R01Store } from "src/containers/mes/EQM/EQM2080_R01/Store_EQM2080_R01";
import { useEQM4010_R01Store } from "src/containers/mes/EQM/EQM4010_R01/Store_EQM4010_R01";


export const AuthactionbarLog = () => {

	const { company, userInfo } = useUserStore();
	const { tabList, activeTab, removeTabList, setAuthactionbarLogModalVisible } = useUiuxStore();
	const { workPlaceList, inoutClassList, wmsCdList, warehouseCdList, systemList, itemCdMap, compCdList, paycollectList } = useCommonCodeStore();
	const { 
		WMS1020_R01LotMap, WMS1020_R01DetailList, editWMS1020_R01, WMS1020_R01Filter, } = useWMS1020_R01Store();
	const {
		WMS1021_R01DetailList, editWMS1021_R01, WMS1021_R01Filter, } = useWMS1021_R01Store();
	const { WMS1030_R01List, selectedWMS1030_R01, WMS1030_R01LotMap, WMS1030_R01DetailList, editWMS1030_R01 } = useWMS1030_R01Store();
	const { editPUR1030_R01, PUR1030_R01DetailList } = usePUR1030_R01Store();
	const { editPUR2010_R01 } = usePUR2010_R01Store();
	const { PRD1010_R01List } = usePRD1010_R01Store();
	const { PRD2010_R01List, selectedPRD2010_R01List, originalPRD2010_R01List } = usePRD2010_R01Store();
	const { PRD3010_R01DetailList, editPRD3010_R01, PRD3010_R01LotList, PRD3010_R01Filter, PRD3010_R01InspectList } = usePRD3010_R01Store();
	const { editSAL1010_R01, SAL1010_R01DetailList } = useSAL1010_R01Store();
	const { editSAL1011_R01 } = useSAL1011_R01Store();
	const { editMST3010_R01 } = useMST3010_R01Store();
	const { SAL2020_R01List, editSAL2020_R01, SAL2020_R01DetailList } = useSAL2020_R01Store();
	const { SYS2010_R01List } = useSYS2010_R01Store();
	const { SYS3010_R01List } = useSYS3010_R01Store();
	const { SYS4100_R01List } = useSYS4100_R01Store();
	const { MST3040_R01List, selectedMST3040_R01, MST3040_R01DetailList } = useMST3040_R01Store();
	const { WMS2020_R01List, selectedWMS2020_R01List, WMS2020_R01DetailList, selectedWMS2020_R01DetailList } = useWMS2020_R01Store();
	const { SYS4030_R01List } = useSYS4030_R01Store();
	const { editSYS4090_R01 } = useSYS4090_R01Store();
	const { editSYS4120_R01 } = useSYS4120_R01Store();
	const { editWMS1140_R01, WMS1140_R01DetailList } = useWMS1140_R01Store();
	const { editPUR6010_R01, PUR6010_R01DetailList } = usePUR6010_R01Store();
	const { editPRD3020_R01 } = usePRD3020_R01Store();
	const { EQM2050_R01Filter, EQM2050_R01List } = useEQM2050_R01Store();
	const { WMS1100_R01DetailList, WMS1100_R01LotList } = useWMS1100_R01Store();
	const { WMS1130_R01Filter, editWMS1130_R01 } = useWMS1130_R01Store();
	const { WMS1131_R01Filter, editWMS1131_R01 } = useWMS1131_R01Store();
	const { editMST4040_R01 } = useMST4040_R01Store();
	const { isTransported: isTransported_SAL1011_R01, productResultComplete: productResultComplete_SAL1011_R01 } = useSAL1011_R01Store();
	const { EQM2080_R01NIDetailList, EQM2080_R01CNDetailList } = useEQM2080_R01Store();
	const { EQM4010_R01DetailList } = useEQM4010_R01Store();
	const { editSAL2070_R01 } = useSAL2070_R01Store();
	const contentRef = useRef<HTMLDivElement>(null);

	const handleCopy = async () => {
		if (contentRef.current) {
			try {
				await navigator.clipboard.writeText(contentRef.current.innerText);
				console.log("클립보드에 복사되었습니다.");
			} catch (err) {
				console.error("복사 실패:", err);
			}
		}
	};

	return (
		<ModalWrapper size="lg" overlay={true}
			onOverlayClick={() => setAuthactionbarLogModalVisible(false)}
			onEscKeyDown={() => setAuthactionbarLogModalVisible(false)}>
			<div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
				<button 
					onClick={handleCopy}
					className={`px-4 py-2 bg-blue-dark hover:bg-blue-600 active:bg-blue-800 text-white rounded-md transition-colors cursor-pointer font-bold`}
				>
					복사하기
				</button>
			</div>
			<div ref={contentRef} style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>

			
			editWMS1020_R01 : {JSON.stringify(editWMS1020_R01, null, 2)} <br/><br/>
			WMS1020_R01DetailList : {JSON.stringify(WMS1020_R01DetailList, null, 2)} <br/><br/>
			WMS1020_R01LotMap : {JSON.stringify(Object.fromEntries(WMS1020_R01LotMap), null, 2)} <br/><br/>

			</div>
		</ModalWrapper>
	)
}